import React, { useState } from "react";
import styled from "styled-components";
import Panel from "../UI/Panel/Panel";
import PanelTitle from "../UI/Panel/PanelTitle";
import PanelContent from "../UI/Panel/PanelContent";
import Grid from "styled-components-grid";
import InsightEditor from "../Modals/InsightEditor";
const Container = styled.div`
  display: flex;
  width: 100%;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;
function Insights({ fixture }) {
  const [selectedFact, setSelectedFact] = useState();

  return (
    <Container>
      <Grid style={{ width: "100%" }}>
        <Grid.Unit size={10 / 10}>
          <Panel>
            <PanelTitle title={"Insights"} />
            <PanelContent>
              <Table>
                <thead>
                  <tr>
                    <TH style={{ width: "100px" }}>Publish</TH>
                    <TH>Fact</TH>
                  </tr>
                </thead>
                <tbody>
                  {fixture &&
                    fixture?.opta_match_facts &&
                    fixture?.opta_match_facts.map((fact) => {
                      let live_fact = fixture?.match_facts?.find(
                        (f) => f.id === fact.id
                      );
                      return (
                        <tr
                          onClick={() => {
                            setSelectedFact({ ...fact, ...live_fact });
                          }}
                        >
                          <td>{live_fact?.publish ? "yes" : "no"}</td>
                          <td>{live_fact?.modified_fact ?? fact?.fact}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </PanelContent>
          </Panel>
          {selectedFact && (
            <InsightEditor
              fact={selectedFact}
              facts={(fixture?.opta_match_facts ?? [])?.map((f) => {
                return {
                  ...f,
                  ...fixture?.match_facts?.find((fa) => fa.id === f.id),
                };
              })}
              fixture={fixture}
              selectFact={(s) => {
                setSelectedFact(s);
              }}
              onCancel={() => {
                setSelectedFact();
              }}
              onSave={() => {
                setSelectedFact();
              }}
            />
          )}
        </Grid.Unit>
      </Grid>
    </Container>
  );
}

export default Insights;
